import React from "react";

// Upload icon — DownloadIcon's twin: the same short, bold arrow and open tray
// (˽), with the arrow pointing up out of it. For actions that send a file
// somewhere rather than fetch one. Inherits button text colour.
export const UploadIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ display: "block" }}
  >
    <path d="M12 13.5 V5" />
    <path d="M7.5 8 L12 3.5 L16.5 8" />
    <path d="M6 16.5 V19.5 H18 V16.5" />
  </svg>
);
